import { ArrowForwardIos } from "@mui/icons-material";
import { Box } from "@mui/material";
import { isValid } from "date-fns";
import { useTranslation } from "react-i18next";
import { Heading2, Text2 } from "../styled";
import { useFormContext } from "react-hook-form";

interface Props {
  workTitle: string;
}

const PreviewItem = ({ workTitle }: Props) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();
  const { workLocation, workStarts, workEnds, type } = watch();

  // Format dates to dd.MM.yyyy
  const formattedWorkStarts =
    workStarts && isValid(workStarts)
      ? new Date(workStarts).toLocaleDateString("fi-FI")
      : "";
  const formattedWorkEnds =
    workEnds && isValid(workEnds)
      ? new Date(workEnds).toLocaleDateString("fi-FI")
      : "";

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        margin: "0px 32px",
        borderRadius: "12px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <img
        src="https://static.uat.helppoydin.com/email/email_eezy_logo.png"
        alt="Company Logo"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          marginRight: "16px",
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Heading2
          noWrap
          textOverflow={"ellipsis"}
          maxWidth={"245px"}
          whiteSpace={"nowrap"}
        >
          {`${workLocation?.name || ""} ${workLocation?.name && workTitle ? "-" : ""} ${workTitle || ""}`}
        </Heading2>
        <Text2
          noWrap
          textOverflow={"ellipsis"}
          maxWidth={"245px"}
          whiteSpace={"nowrap"}
        >
          {`${workLocation?.address?.street || ""} ${workLocation?.address?.street && workLocation?.address?.city ? "," : ""} ${workLocation?.address?.city || ""}`}
        </Text2>
        <Text2
          sx={{ color: "#696969" }}
          noWrap
          textOverflow={"ellipsis"}
          maxWidth={"245px"}
          whiteSpace={"nowrap"}
        >
          {type === "Continuous" && workLocation?.name
            ? t("order:continuousType")
            : `${formattedWorkStarts || ""} ${formattedWorkStarts && formattedWorkEnds ? "-" : ""} ${formattedWorkEnds || ""}`}
        </Text2>
      </Box>
      <ArrowForwardIos fontSize="small" />
    </Box>
  );
};

export default PreviewItem;
